if (!customElements.get('redd-story-journey')) customElements.define('redd-story-journey', class extends HTMLElement {
  connectedCallback() {
    this.nav = this.querySelector('.redd-journey-nav');
    this.track = this.querySelector('.redd-journey-nav__track');
    this.links = Array.from(this.nav.querySelectorAll('a'));
    this.chapters = this.links.map(link => document.getElementById(link.hash.slice(1)));
    this.events = new AbortController();
    this.queue = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        const boundary = (parseFloat(getComputedStyle(this.nav).top) || 0) + this.nav.offsetHeight + 28;
        let active = 0;
        this.chapters.forEach((chapter, index) => { if (chapter?.getBoundingClientRect().top <= boundary) active = index; });
        const resized = this.layoutChanged || this.width !== this.track.clientWidth;
        this.layoutChanged = false;
        this.width = this.track.clientWidth;
        const changed = active !== this.active;
        this.active = active;
        this.links.forEach((link, index) => {
          if (index === active) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
        const item = this.links[active].getBoundingClientRect();
        const menu = this.track.getBoundingClientRect();
        if ((changed || resized) && (item.left < menu.left || item.right > menu.right)) {
          this.track.scrollTo({left: this.track.scrollLeft + item.left - menu.left - (menu.width - item.width) / 2, behavior: 'smooth'});
        }
        // Follow the actual label edge, including horizontal scrolling and translated widths.
        const nav = this.nav.getBoundingClientRect();
        const end = Math.max(0, Math.min(nav.width, item.right - nav.left));
        this.style.setProperty('--journey-progress', `${end}px`);
      });
    };
    window.addEventListener('scroll', this.queue, {passive: true, signal: this.events.signal});
    window.addEventListener('resize', this.queue, {passive: true, signal: this.events.signal});
    this.track.addEventListener('scroll', this.queue, {passive: true, signal: this.events.signal});
    this.observer = new ResizeObserver(() => { this.layoutChanged = true; this.queue(); });
    this.observer.observe(this);
    this.observer.observe(this.track);
    this.links.forEach(link => this.observer.observe(link));
    this.queue();
  }
  disconnectedCallback() {
    this.events?.abort();
    this.observer?.disconnect();
    cancelAnimationFrame(this.frame);
    this.frame = null;
    this.active = null;
  }
});
